import "../style/NewRecoverPassword.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { useFormat } from "../../../hooks/useFormat";
import { useEffect } from "react"
export function useNewRecoverPassword() {
    const { checkPassword } = useFormat();

    const route = useNavigate();
    const parameters = useLocation();
    useEffect(() => {
        console.log(parameters);
    }, []);

    const formik = useFormik({
        initialValues: {
            phoneNumber: parameters.state.phoneNumber,
            password: "",
        },
        onSubmit: async (values) => {
            route("/SignUpOTPScreen", {
                state: {
                    screen: "NewRecoverPassword",
                    phoneNumber: values.phoneNumber,
                    newPassword: values.password,
                },
            });
        },
        validate: (values) => {
            const errors = {};
            console.log(values);
            if (!values.password) {
                errors.password = 'Ingresa una contraseña.'
            } else {
                if (values.password.length < 6) {
                    errors.password = 'Tu contraseña debe tener al menos 6 caracteres.'
                } else {
                    if (!checkPassword(values.password)) {
                        errors.password = 'Escribe una contraseña valida. (Usa letras, numeros y signos)'
                    }
                }
            }

            return errors;
        },
    });

    return {
        formik,
        parameters,
        route
    }
}